import BaseModel from '../core/BaseModel'
export default class EvaluationFormModel extends BaseModel {
    constructor() {
        super({
            tableName: 'evaluation_form', label: "Kế hoạch đánh giá", display_key: 'name',name: "area",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            name: {
              name: "name",
              type: "String",
              label: "Phiếu đánh giá",
              width: 15,
              filter: { type: "input", match: "contains" },
            },
            areas: {
              name: "areas",
              label: "Khu vực",
              type: "MultiSelect",
              width: 11,
              filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
              },
            },
            department: {
              name: "department",
              label: "Bộ phận",
              type: "MultiSelect",
              width: 11,
              filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
              },
            },
            work_name: {
              name: "work_name",
              type: "String",
              label: "Công việc",
              width: 10,
              filter: { type: "input", match: "contains" },
            },
            total_r: {
              name: "total_r",
              type: "CustomUrl",
              label: "Tổng R",
              width: 8,
            },
            danger_total: {
              name: "danger_total",
              type: "CustomUrl",
              label: "Mối nguy cao",
              width: 10,
              class: "center"
            },
            implementer_name_search: {
              name: "implementer_name_search",
              type: "String",
              label: "Người thực hiện",
              width: 12,
              filter: { type: "input", match: "contains" },
            },
            expiration_date : {
              name: 'expiration_date',
              type: "CustomCss",
              label: 'Hạn chót',
              width: 8,
              class: "small-col",
              filter: { type: "DateRange", match: "contains" },
            },
            status : {
              name: 'status', 
              type: "Selection", 
              custom: 'SelectionText',
              label: 'Trạng thái phiếu',
              class: '',
              width: 5,
              options: [
                {label: "Mới",value: 'NEW'},
                {label: "Chờ review",value: 'REVIEW'},
                {label: "Chờ approve",value: 'WAITTING_APPROVED'},
                {label: "Đã approve",value: 'APPROVE'},
                {label: "Đã đóng",value: 'COMPLETE'}
              ],
              filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            
            updated_at : {
              name: 'updated_at',
              type: "Datetime",
              label: 'Cập nhật cuối',
              width: 8,
            },
        })
    }

}